import type { Stage as KonvaStage } from "konva/lib/Stage";

const sceneMimeType = "image/png";

function downloadBlob(blob: Blob, fileName: string) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}

function canvasToBlob(canvas: HTMLCanvasElement, mimeType: string): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
        return;
      }

      reject(new Error("Failed to create image blob."));
    }, mimeType);
  });
}

async function fetchImageBlob(url: string): Promise<Blob> {
  const response = await fetch(url, { credentials: "omit" });
  if (!response.ok) {
    throw new Error(`Image download failed: ${response.status}`);
  }

  return await response.blob();
}

export async function downloadSocialPostPreviewImage({
  stage,
  previewAssetUrl,
  fileName,
}: {
  stage: KonvaStage | null;
  previewAssetUrl: string | null;
  fileName: string;
}) {
  if (stage) {
    const canvas = stage.toCanvas();
    const blob = await canvasToBlob(canvas, sceneMimeType);
    downloadBlob(blob, fileName);
    return;
  }

  if (previewAssetUrl) {
    const blob = await fetchImageBlob(previewAssetUrl);
    downloadBlob(blob, fileName);
    return;
  }

  throw new Error("No image is available for this post yet.");
}
